import { useRef, useEffect, useState } from "react";
import Lottie from "react-lottie";
import * as animationData from "./lottie/PleaseWait.json";
import * as handshakeAnimation from "./lottie/SuccessHandshake.json";
import * as waitingAnimationAirplane from "./lottie/waitingAnimationAirplane.json";
import * as successTransaction from "./lottie/success.json";
import * as waitingClient from "../../lottie/lottie_waiting.json";


import VideoCallNewest from "../../pages/VideoCallNewest";

// import '../../styles/pages/app-chat.css'

import "../../styles/chat.css";

// AMPLIFY
import { generateClient } from "aws-amplify/api";

// SUBSCRIPTION FOR PINGING WEBSOCKET AND REAL-TIME UPDATES
import {
  onCreateChatMessage,
  onUpdateChatMessage,
  onDeleteChatMessage,

  onUpdateChatNegotiation,
  onUpdateTransaction
} from "../../graphql/subscriptions";

// MUTATIONS IS FOR INSERT , UPDATE AND DELETE
// MUTATIONS FOR CREATE , UPDATE AND DELETE
import {
  createChatMessage,
  updateChatMessage,
  deleteChatMessage,

  updateChatNegotiation,
  updateTransaction,
  updateTransactionLawyer
} from "../../graphql/mutations";

// QUERIES FOR LIST
import { listChatMessage } from "../../graphql/queries";




import { useAuth } from "../../contexts/AuthContext";
import useModelData from "../../hooks/useModelData";

import { format } from "date-fns";
import Swal from "sweetalert2";
import BackdropModalSmall from "../../components/modals/backdrop_modal_small";

import CurrencyInput from 'react-currency-input-field';
import CatchTheDotGame from "../../pages/CatchTheDotGame";


import moment from 'moment-timezone';
import finalPropsSelectorFactory from "react-redux/es/connect/selectorFactory";
import titleCaseString from "../../utils/titleCaseUtils";



const checkDocumentIfExists = (name, array) => {
  return array.includes(name);
};

function getTimestamp() {
  const formattedDate = moment().tz('Asia/Manila').format('YYYY-MM-DD HH:mm:ss');
  return formattedDate;
}


const LoadingAnimationWaitingForPrincipal = ({ selectedItem, acceptedTransaction,acceptedLawyer, currentlyDoingOfPrincipal, handleDeleteTransactionLawyer, currentAcceptedTransactionLawyerId, setOpen,openChat,setOpenChat,setChatId,chatId }) => {



  const documentNames = [
    'DEED OF DONATION', 'AFFIDAVIT OF LOSS','NON-DISCLOSURE AGREEMENT','SECRETARY\'S CERTIFICATE'
  ];
  

  useEffect(() => {
    // if (checkDocumentIfExists(selectedItem.document_name?.toUpperCase(), documentNames)) {
    //   setOpenChat(false);
    // }
    // else{
    //   setOpenChat(true);
    // }
      // setOpenChat(true);

    console.log("sssss",selectedItem);
 

      setTimerStartedForPrincipal(true);
      const timer2 = setInterval(() => {
        setWaitingTimeForPrincipal(prevTime => prevTime + 1);
      }, 1000);

      // Clear the timer when the component is unmounted or condition changes
      return () => clearInterval(timer2);

  }, [selectedItem]);


  console.log("acceptedTransaction",acceptedTransaction);

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: acceptedTransaction ? handshakeAnimation : waitingAnimationAirplane,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  const defaultOptionsWaiting = {
    loop: true,
    autoplay: true,
    animationData:waitingClient ,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };


  const defaultOptionsLottieSuccess = {
    loop: true,
    autoplay: true,
    animationData: successTransaction,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  const hanleMakeAnotherTransaction = () => {
    setOpen(false);
  };

  const { user } = useAuth();
  const lawyerFullName = `${user.first_name} ${user.last_name}`;

  const client = generateClient();
  const [message, setMessage] = useState("");

  const [chat, setChat] = useState([]);


  useEffect(() => {

    // FETCH INITIAL MESSAGE
    const fetchChat = async () => {
      const user_profile_id = user.user_id;
      const transaction_id = selectedItem.transaction_id;

      const filter = {
        or: [
          { user_profile_id: { eq: user_profile_id } },
          { user_profile_id: { eq: selectedItem.user_profile_id } }, // Example for another condition
        ],
        transaction_id: { eq: transaction_id },
      };

      const variables = {
        filter,
        sortDirection: "DESC",
        sortField: "createdAt",
      };

      try {
        // Step 1: Check if the user already exists
        const checkResponse = await client.graphql({
          query: listChatMessage,
          variables: variables,
        });

        const initialMessage = checkResponse.data.listChatMessages.items;
        setChat(initialMessage);

        if (initialMessage && initialMessage.length > 0) {
          // Step 2: Sort messages by 'createdAt' in descending order (newest first)
          const sortedMessages = initialMessage.sort((a, b) => {
            return new Date(a.createdAt) - new Date(b.createdAt); // For ascending order (oldest first)
          });

          setChat(sortedMessages);
          setChatId(sortedMessages[0].chat_id);

        } else {
          setChat([]);
        }
      } catch (error) {
        console.error("Error fetching initial chat messages", error);
      }
    };

    fetchChat();

    // Subscribe to real-time updates when a new transaction is created
    const createSub = client.graphql({ query: onCreateChatMessage }).subscribe({
      next: ({ data }) => {
        const newMessage = data.onCreateChatMessage;
        setChat((prevChat) => [...prevChat, newMessage]);
        if (!chatId) {
          setChatId(newMessage.chat_id);
          setChatError(false);
        }
      },
      error: (error) => {
        console.warn("Subscription error:", error);
      },
    });


    // Subscribe to real-time updates when a transaction is updated
    const updateSub = client.graphql({ query: onUpdateChatMessage }).subscribe({
      next: ({ data }) => {
        const updatedMessage = data.onUpdateChatMessage;
        setChat((prevChat) =>
          prevChat.map((msg) =>
            msg.id === updatedMessage.id ? updatedMessage : msg
          )
        ); // Update the message in the list
        console.log("Updated Message:", updatedMessage);
      },
      error: (error) => {
        console.warn("Subscription error:", error);
      },
    });

    // Subscribe to real-time updates when a transaction is deleted
    const deleteSub = client.graphql({ query: onDeleteChatMessage }).subscribe({
      next: ({ data }) => {
        const deletedMessageId = data.onDeleteChatMessage.id;
        setChat((prevChat) =>
          prevChat.filter((msg) => msg.id !== deletedMessageId)
        ); // Remove the deleted message from the list
        console.log("Deleted Message ID:", deletedMessageId);
      },
      error: (error) => {
        console.warn("Subscription error:", error);
      },
    });


    // UPDATE CHAT NEGOTIATION
    const updateSubChatNegotiation = client.graphql({ 
      query: onUpdateChatNegotiation 
    }).subscribe({
      next: ({ data }) => {
        const updatedNegotiation = data.onUpdateChatNegotiation;
        console.log("Updated Negotiation:", updatedNegotiation);
      },
      error: (error) => {
        console.warn("Subscription error:", error);
      },
    });



    // UPDATE TRANSACTION
    // Subscribe to real-time updates when a transaction is updated
     const updateSubTransaction = client.graphql({ query: onUpdateTransaction }).subscribe({
      next: ({ data }) => {
        const updatedTransaction = data.onUpdateTransaction;
        console.log("Updated updatedTransaction:", updatedTransaction);

      },
      error: (error) => {
        console.warn("Subscription error:", error);
      },
    });






    // Cleanup subscriptions on component unmount
    return () => {
      createSub.unsubscribe();
      updateSub.unsubscribe();
      deleteSub.unsubscribe();

      // NEGOTIATION
      updateSubChatNegotiation.unsubscribe();

      // TRANSACTION
      updateSubTransaction.unsubscribe();
    };
  }, []);


  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleCreateChatMessage(e);
    }
  };

  const [chatError, setChatError] = useState(false);

  const [sentInitialMessage,setSentInitialMessage] = useState(false)
   const handleCreateInitialChatMessage = async () => {
    

     if (chatId) {
       setChatError(false);
       const input = {
         chat_id: chatId,
         user_profile_id: user.user_id,
         message: `Hi, this is Atty. ${titleCaseString(lawyerFullName)} and I\’ve received your message. It will be read shortly, and you\’ll get a response as soon as possible.Thank you for waiting.`,
         date_created: getTimestamp(),
         transaction_id: selectedItem.transaction_id,
       };
       try {

        console.log("inputinputinputinput",input);

         const mutationVariables = { input };
         await client.graphql({
           query: createChatMessage,
           variables: mutationVariables,
         });
         setSentInitialMessage(true);
         setMessage("");
       } catch (error) {
         setChatError(true);
       }
     }

   
  };

useEffect(() => {
  if (chatId && !sentInitialMessage) {
    
    handleCreateInitialChatMessage();
  }
}, [chatId]);



  const handleCreateChatMessage = async (e) => {
    e.preventDefault();
    setChatError(false);
    const input = {
      chat_id: chatId,
      user_profile_id: user.user_id,
      message: message,
      date_created: getTimestamp(), 
      transaction_id: selectedItem.transaction_id,
    };
    try {
      const mutationVariables = { input };
      await client.graphql({
        query: createChatMessage,
        variables: mutationVariables,
      });
      setMessage("");
    } catch (error) {
      setChatError(true);
    }
  };

  // created_by

  async function handleDeleteChatMessage() {
 
    
    // Find the messages that match chat_id = chatIdToDelete
    const messagesToDelete = chat.filter(message => message.chat_id === chatId);
  
    if (messagesToDelete.length === 0) {
      console.log(`No messages found with chat_id: ${chatId}`);
      return;
    }
  
    try {
      // Loop through each message and delete it
      for (const message of messagesToDelete) {
        const deleteVariables = {
          input: {
            id: chatId, // Use the unique identifier for deletion
          },
          condition: {
            user_profile_id: { eq: user.user_id }
          }
        };
  
        // Call the delete mutation for each message
        const deleteResponse = await client.graphql({
          query: deleteChatMessage, // Your mutation query
          variables: deleteVariables,
        });
  
        console.log(`Message with id ${message.id} deleted successfully`, deleteResponse);
      }
  
    } catch (error) {
      console.error("Error deleting messages:", error);
    }
  }


  // Chat Negotiation
  async function handleUpdateChatNegotiation(status) {
    try {
      const updateVariables = {
        input: {
          id: chatId,
          status: status.toUpperCase(),
        },
         condition: {
          lawyer_id: { eq: user.user_id }
        }
      };

      const updateResponse = await client.graphql({
          query: updateChatNegotiation,
          variables: updateVariables,
        });

        console.log("status updated:",updateResponse.data.updateChatNegotiation);

      } catch (error) {
        console.error("Error deleting messages:", error);
      }
  }


  // Transaction
  async function handleUpdateTransaction() {
    try {
      const updateVariables = {
        input: {
          id: selectedItem.id,
          lawyer_id: null,
          transaction_status: "PENDING",
        },
        condition: {
          lawyer_id: { eq: user.user_id }
        }
      };

      const updateResponse = await client.graphql({
          query: updateTransaction,
          variables: updateVariables,
        });

        console.log("status updated:",updateResponse.data.updateTransaction);

      } catch (error) {
        console.error("Error updating transaction lawyer id messages:", error);
      }
  }


  // Confirm Amount
  const [amount,setAmount] = useState("")
  const handleValueChange = (value) => {
    setAmount(value);
  };
  const [openAmount, setOpenAmount] = useState(false);
  
  const handleCloseAmount = () => {
    setOpenAmount(false);
  };

  const inputAmountRef = useRef(null);

  function handleConfirmAmount(status) {
    setOpenAmount(true)
    setTimeout(() => {
      inputAmountRef.current.focus();
    }, 500);
  }




  async function handleSaveAmount(e) {
    // Display the Swal confirmation dialog
    const result = await Swal.fire({
      title: 'Save amount',
      text: 'Do you want to save the amount?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: 'btn-danger',
      cancelButtonColor: 'btn-secondary',
      confirmButtonText: 'Yes and end the negotiation!',
      cancelButtonText: 'No, cancel',
      confirmButtonColor: '#03c3ec',
      cancelButtonColor: '#ff3e1d',
    });
  
    // If the user confirms (clicks "Yes")
    if (result.isConfirmed) {

      if(chatId){
          // UPDATE TRANSACTION
          console.log(amount);
          try {
            const updateVariables = {
              input: {
                id                : selectedItem.id,
                document_price    : amount,
                lawyer_id         : user.user_id,
                negotiation_status:"SUCCESS"
              }
            };

            // Make the GraphQL request (await the response)
            const updateResponse = await client.graphql({
              query: updateTransaction,
              variables: updateVariables,
            });
            console.log("document_price",updateResponse);


          } catch (error) {
            console.error("Error updating 1:", error);
          }



          try {
            
          // UPDATE CHAT NEGOTIATION
          const updateVariablesChatNegotiation = {
            input: {
              id    : chatId,
              status: "APPROVED",
            }
          };



          // Make the GraphQL request (await the response)
          const updateResponseChatNegotiation = await client.graphql({
            query: updateChatNegotiation,
            variables: updateVariablesChatNegotiation,
          });

          console.log("updateResponseChatNegotiation",updateResponseChatNegotiation);


 

          } catch (error) {
            console.error("Error updating 2:", error);
          }

          try {
            
          // UPDATE TRANSACTION LAWYER
          const updateVariablesTransactionLawyer = {
            input: {
              id    : currentAcceptedTransactionLawyerId,
              transaction_status: "ACCEPTED",
              document_price: amount,
            }
          };



          // Make the GraphQL request (await the response)
          const updateResponseTransactionLawyer = await client.graphql({
            query: updateTransactionLawyer,
            variables: updateVariablesTransactionLawyer,
          });

          console.log("status updateResponseTransactionLawyer:", updateResponseTransactionLawyer);


          } catch (error) {
            console.error("Error updating 3:", error);
          }
      }
      else{
        Swal.fire({
                title: 'Agreed amount required.',
                icon: 'error',
                text: 'Oops!System detected that you\'re not agreed on amount.',
                customClass: {
                  confirmButton: 'btn btn-success'
                },
                confirmButtonColor: '#03c3ec',
                cancelButtonColor: '#ff3e1d',
              });
      }
      
    } else {
      // Handle the case when the user clicks "No" or dismisses the modal
      console.log("Action canceled");
    }
  }
  


//  SCROLL TO LAST MESSAGE
  const lastMessageRef = useRef(null);
  useEffect(() => {
    if (lastMessageRef.current) {
      lastMessageRef.current.scrollIntoView({ behavior: 'smooth', block: 'end' });
    }
  }, [chat]);



  // WAITING TIMER
  const [waitingTime, setWaitingTime] = useState(0); // To track the waiting time
  const [timerStarted, setTimerStarted] = useState(false); // To track if the timer started
  useEffect(() => {
    if (currentlyDoingOfPrincipal.toUpperCase() === 'ADDING WITNESS' || currentlyDoingOfPrincipal.toUpperCase() === 'FOR PAYMENT') {
      setTimerStarted(true);
      const timer = setInterval(() => {
        setWaitingTime(prevTime => prevTime + 1);
      }, 1000);

      // Clear the timer when the component is unmounted or condition changes
      return () => clearInterval(timer);
    } else {
      setTimerStarted(false);
      setWaitingTime(0); // Reset waiting time when it's no longer "ADDING WITNESS"
    }
  }, [currentlyDoingOfPrincipal]);

  const handleCancel = () => {
    setWaitingTime(0);
    setTimerStarted(false);
  };

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes} minutes and ${remainingSeconds} seconds`;
  };




  // TIME WAITING FOR PRINCIPAL TO ACCEPT
  const [waitingTimeForPrincipal, setWaitingTimeForPrincipal] = useState(0); // To track the waiting time
  const [timerStartedForPrincipal, setTimerStartedForPrincipal] = useState(false); // To track if the timer started

  
  const handleCancelForPrincipal = () => {
    setWaitingTimeForPrincipal(0);
    setTimerStartedForPrincipal(false);
  };




 
  console.log("sss",currentAcceptedTransactionLawyerId,acceptedLawyer,currentlyDoingOfPrincipal,user.user_id);


  if(acceptedLawyer && parseInt(acceptedLawyer) !== parseInt(user.user_id)){
    return(
      <div className="d-flex justify-content-center align-items-center" style={{ height: "100vh", position: "fixed", top: 0, left: 0, width: "100%", backgroundColor: "rgba(1, 1, 1, 0.8)", zIndex: 1000, }} >
        <div className="d-flex flex-column align-items-center p-4 card"  >

          {!openChat &&
            <div className="border rounded-3  p-4">
              {/* <Lottie isClickToPauseDisabled={true} options={defaultOptions} height={350} width={350} /> */}
            </div>
          }

          <span className="fw-bold fs-6 text-center mt-2" >
            This transaction is being negotiated with another lawyer.<br/> If they reject the amount, it will be made available to all lawyers.<br/> For now,
               <span className="text-center text-danger">
            you may now close this request.
          </span>
          </span>

           {/* <button
            type="button"
            className="btn btn-outline-danger mt-3 mb-1"
            onClick={() => {
              handleGGsad(currentAcceptedTransactionLawyerId);
            }}>
             GG
          </button> */}
       
          <button
            type="button"
            className="btn btn-outline-danger mt-3 mb-1"
            onClick={() => {
              handleDeleteTransactionLawyer(currentAcceptedTransactionLawyerId);
              // handleDeleteChatMessage();
              // handleUpdateChatNegotiation("REJECTED");
              handleCancel();
            }}>
             Close
          </button>
        </div>
      </div>
    )
  }
  

  return (
    
    <div className="d-flex justify-content-center align-items-center" style={{ height: "100vh", position: "fixed", top: 0, left: 0, width: "100%", backgroundColor: "rgba(1, 1, 1, 0.8)", zIndex: 1000, }} >
      <div className="d-flex flex-column align-items-center p-5 card"  >

      {currentlyDoingOfPrincipal !== "RELEASED" && 
          <div className="border border-warning rounded-3  p-4">
            {/* <Lottie isClickToPauseDisabled={true} options={defaultOptions} height={350} width={350} /> */}

             <div className="sk-grid sk-warning">
                <div className="sk-grid-cube bg-warning"></div>
                <div className="sk-grid-cube bg-warning"></div>
                <div className="sk-grid-cube bg-warning"></div>
                <div className="sk-grid-cube bg-warning"></div>
                <div className="sk-grid-cube bg-warning"></div>
                <div className="sk-grid-cube bg-warning"></div>
                <div className="sk-grid-cube bg-warning"></div>
                <div className="sk-grid-cube bg-warning"></div>
                <div className="sk-grid-cube bg-warning"></div>
              </div>
          </div>
      }


          {acceptedTransaction ? (
          <>
            {currentlyDoingOfPrincipal.toUpperCase() === "ADDING WITNESS" && (
               <div className="d-flex justify-content-center align-items-center" style={{ height: "100vh", position: "fixed", top: 0, left: 0, width: "100%", backgroundColor: "rgba(1, 1, 1, 0.8)", zIndex: 1000, }} >
                  <div className="d-flex flex-column align-items-center p-4 card"  >

                    <Lottie isClickToPauseDisabled={true} options={defaultOptionsWaiting} height={350} width={350} />

                    <span className="fw-bold fs-5 text-center mt-0 text-uppercase" style={{ letterSpacing: 1 }} >
                      Your request has been accepted by the principal.
                    </span>
                    <span className="fw-bold fs-6 text-center my-4 text-uppercase text-primary" style={{ letterSpacing: 1 }} >
                      Principal is now adding witness.
                    </span>

                  <div className={`d-flex flex-column flex-sm-row  flex-lg-row flex-md-row ${waitingTime >= 120 ? 'justify-content-lg-between justify-content-md-between justify-content-sm-between' : ''} px-4 w-100`} >

                    {timerStarted &&
                      <div className="d-flex">
                        <div className="avatar flex-shrink-0 me-2">
                          <span className="avatar-initial rounded bg-label-warning">
                            <i className="bx bx-time-five bx-sm"></i>
                          </span>
                        </div>
                        <div>
                          <h6 className="mb-0 text-nowrap">{formatTime(waitingTime)}</h6>
                          <small>Waiting Duration</small>
                        </div>
                      </div>
                    }


                    {waitingTime >= 5 && (
                      <button
                        type="button"
                        className="btn btn-outline-primary"
                        onClick={() => {
                          handleDeleteTransactionLawyer(
                            currentAcceptedTransactionLawyerId
                          );
                          handleDeleteChatMessage();
                          handleUpdateChatNegotiation("REJECTED");
                          handleCancel();
                        }}>
                        <i className="bx bxs-hand me-1"></i> Cancel1
                      </button>
                    )}
                  </div> 

                    
                    
                  </div>
                </div>
            )}

            {currentlyDoingOfPrincipal === "FOR OATH" && (
              <>


                <span className=" fw-bold fs-6 mt-4 text-center">
                  THE PRINCIPAL IS READY AND IS PREPARED TO PROCEED WITH OATH-TAKING.<br />
                  <span className="text-info">CLICK GENERATE MEETING AND JOIN AFTERWARDS.</span>
                </span>

                <VideoCallNewest selectedItem={selectedItem} />
              </>
            )}

            {currentlyDoingOfPrincipal === "FOR PAYMENT" && (
              <>

                <span className=" fw-bold fs-6 text-center my-3">
                  PRINCIPAL IS NOW PROCESSING PAYMENT.<br /> PLEASE WAIT FOR A WHILE.
                </span>

                {timerStarted &&

                  <div className="d-flex">
                    <div className="avatar flex-shrink-0 me-2">
                      <span className="avatar-initial rounded bg-label-warning">
                        <i className="bx bx-time-five bx-sm"></i>
                      </span>
                    </div>
                    <div>
                      <h6 className="mb-0 text-nowrap">{formatTime(waitingTime)}</h6>
                      <small>Waiting Duration.</small>
                    </div>
                  </div>

                }

                {waitingTime >= 120 &&
                  <>
                    <button
                      type="button"
                      className="btn btn-outline-danger mt-3"
                      onClick={() => {
                        // handleDeleteTransactionLawyer(currentAcceptedTransactionLawyerId);
                        // handleDeleteChatMessage();
                        // handleUpdateChatNegotiation("REJECTED");
                        // handleCancel();
                        // handleUpdateTransaction();
                        handleCancel();
                        setOpen(false);

                      }}>
                      <i className="bx bx-x me-1"></i> Cancel Transaction6
                    </button>

                    <span className="fw-bold ">Please note that canceling the transaction may result in negative feedback.</span>
                  </>

                }


                {/* <CatchTheDotGame/> */}


              </>
            )}

           


            {currentlyDoingOfPrincipal === "PENDING" && openChat && acceptedLawyer && (
              <div className="d-flex justify-content-center align-items-center" style={{ height: "100vh", position: "fixed", top: 0, left: 0, width: "100%", backgroundColor: "rgba(1, 1, 1, 0.8)", zIndex: 1000, }} >
                <div className="d-flex flex-column align-items-center p-4 card"  >

                  <Lottie isClickToPauseDisabled={true} options={defaultOptionsWaiting} height={350} width={350} />

                  <span className="fw-bold fs-5 text-center mt-2 text-uppercase" style={{ letterSpacing: 1 }} >
                    Awaiting client approval ..
                  </span>
                  <button
                    type="button"
                    className="btn btn-outline-danger mt-3"
                    onClick={() => {
                      handleDeleteTransactionLawyer(currentAcceptedTransactionLawyerId);
                      handleDeleteChatMessage();
                      handleUpdateChatNegotiation("REJECTED");
                      handleCancel();
                    }}>
                    <i className="bx bx-x me-1"></i> Cancel Transaction7
                  </button>
                </div>
              </div>
            )}


             {currentlyDoingOfPrincipal === "PROCESSING DOCUMENT" && (
              <>
                <span className=" fw-bold fs-6 mt-4 text-center">
                  THE DOCUMENT IS CURRENTLY BEING PROCESSED <br/> AND WILL BE SENT VIA EMAIL SHORTLY. <br/>
                </span>
                  <span className="text-info my-2 fw-bold fs-6  text-center">YOU CAN TRANSACT ANOTHER.</span>


                <button type="button" onClick={() => hanleMakeAnotherTransaction()} className="btn btn-success text-nowrap" >
                  Transact Another
                </button>
              </>
            )}


             {currentlyDoingOfPrincipal === "RELEASED" && (
              <>
                <Lottie isClickToPauseDisabled={true} options={defaultOptionsLottieSuccess} height={250} width={450} />
                <span className=" fw-bold fs-6 mt-n4 mb-2" style={{ letterSpacing: "1px" }} >
                  TRANSACTION COMPLETED!
                </span>

                <button type="button" onClick={() => hanleMakeAnotherTransaction()} className="btn btn-success text-nowrap" >
                  Transact Another
                </button>
              </>
            )}





          </>
          ) : (
            <>
              {currentlyDoingOfPrincipal.toUpperCase() === "ADDING WITNESS" ? (

                <div className="d-flex justify-content-center align-items-center" style={{ height: "100vh", position: "fixed", top: 0, left: 0, width: "100%", backgroundColor: "rgba(1, 1, 1, 0.8)", zIndex: 1000, }} >
                  <div className="d-flex flex-column align-items-center p-4 card"  >

                    <Lottie isClickToPauseDisabled={true} options={defaultOptionsWaiting} height={350} width={350} />

                    <span className="fw-bold fs-5 text-center mt-0 text-uppercase" style={{ letterSpacing: 1 }} >
                      Your request has been accepted by the principal.
                    </span>
                    <span className="fw-bold fs-6 text-center my-4 text-uppercase text-primary" style={{ letterSpacing: 1 }} >
                      Principal is now adding witness.
                    </span>

                    <div className={`d-flex flex-column flex-sm-row  flex-lg-row flex-md-row ${waitingTime >= 120 ? 'justify-content-lg-between justify-content-md-between justify-content-sm-between' : ''} px-4 w-100`} >

                      {timerStarted &&
                        <div className="d-flex">
                          <div className="avatar flex-shrink-0 me-2">
                            <span className="avatar-initial rounded bg-label-warning">
                              <i className="bx bx-time-five bx-sm"></i>
                            </span>
                          </div>
                          <div>
                            <h6 className="mb-0 text-nowrap">{formatTime(waitingTime)}</h6>
                            <small>Waiting Duration</small>
                          </div>
                        </div>
                      }


                      {waitingTime >= 120 && (
                        <button
                          type="button"
                          className="btn btn-outline-primary"
                          onClick={() => {
                            handleDeleteTransactionLawyer(
                              currentAcceptedTransactionLawyerId
                            );
                            handleCancel();
                          }}>
                          <i className="bx bxs-hand me-1"></i> Cancel1
                        </button>
                      )}
                    </div>

                  </div>
                </div>

              )
                :
                (
                  <>
                    <span className=" fw-bold fs-6 mt-4 mb-2 text-center" style={{ letterSpacing: "1px" }} >
                      {chatId ? 'AFFIANT WANTS TO NEGOTIATE WITH YOU..' : 'WAITING FOR AFFIANT...'}
                    </span>


                    {timerStartedForPrincipal &&
                      <div className="d-flex">
                        <div className="avatar flex-shrink-0 me-2">
                          <span className="avatar-initial rounded bg-label-warning">
                            <i className="bx bx-time-five bx-sm"></i>
                          </span>
                        </div>
                        <div>
                          <h6 className="mb-0 text-nowrap">{formatTime(waitingTimeForPrincipal)}</h6>
                          <small>Waiting Time...</small>
                        </div>
                      </div>
                    }
                  </>

                )
              }
              {!currentlyDoingOfPrincipal && !openChat && (
                <div className="d-flex justify-content-between w-100 gap-2">
                  <div className="d-flex w-100">
                    <button type="button" className="btn btn-label-danger mt-3 w-100" onClick={() => {
                      handleDeleteTransactionLawyer(currentAcceptedTransactionLawyerId);
                      handleDeleteChatMessage();
                      handleUpdateChatNegotiation("REJECTED");
                      handleUpdateTransaction();

                    }}>
                      {/* <i className="bx bxs-hand me-1"></i> Cancel3 */}
                      <i className="bx bxs-hand me-1 Cancel3"></i> Cancel
                    </button>
                  </div>

                  {chatId &&
                    <div className="d-flex w-100">
                      <button type="button" className="btn btn-info mt-3 w-100" onClick={() => { setOpenChat(true); }} >
                        <i className="bx bxs-message me-1"></i> Negotiate
                      </button>
                    </div>
                  }


                </div>
                
              )}

              {currentlyDoingOfPrincipal.toUpperCase() === "PENDING" &&
                !openChat && (
                  <div className="d-flex justify-content-between w-100 gap-2">
                  <div className="d-flex w-100">
                    <button type="button" className="btn btn-label-danger w-100 mt-3"
                      onClick={() => {
                        handleDeleteTransactionLawyer(
                          currentAcceptedTransactionLawyerId
                        );
                        handleDeleteChatMessage();
                        handleUpdateChatNegotiation("REJECTED");
                        handleUpdateTransaction();

                      }}>
                      <i className="bx bxs-hand me-1"></i> Cancel4
                    </button>
                  </div>



                  {chatId && (
                    <div className="d-flex w-100 position-relative">
                      <div className="talkbubble position-absolute start-50 translate-middle-x blink" style={{ top: '-20px' }}>
                        New message
                      </div>
                      <button type="button" className="btn btn-label-info mt-3 w-100 text-nowrap d-inline-block" onClick={() => { setOpenChat(true); }} >
                        <i className="bx bxs-message me-1"></i> Negotiate
                      </button>
                    </div>
                  )}
                        
                  

                </div>
                )}

          
                <BackdropModalSmall open={openChat} handleClose={()=>setOpenChat(false)} modalTitle="Send Message" >
                    <div>
                      <div className="card card-action  chat-history-wrapper w-100 border shadow-none">
                        <div className="card-header align-items-center pb-2">
                          <h5 className="card-action-title mb-0">
                            <i className="bx bxs-chat me-2" />
                            Chat
                          </h5>
                        </div>

                        <div className="card-body  " style={{ height: 400, overflowY: "auto", background: "#f7f8f8", }} >
                          {chatError && (
                            <div className="alert alert-danger alert-dismissible mt-4 d-flex flex-column align-items-start w-100" role="alert" >
                              <span>
                                Oops! You can't initiate chat. Only the principal is
                                allowed. You can reply only.
                              </span>

                              <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close" ></button>
                            </div>
                          )}

                          {/* Chat Messages */}

                          <ul className="list-unstyled chat-history mt-2">
                            {chat.length > 0 &&
                              chat.map((data, index) => {
                                // Extracting hour and minute from the current message and the previous one
                                const currentTime = new Date(data.createdAt);
                                const previousTime =
                                  index > 0
                                    ? new Date(chat[index - 1].createdAt)
                                    : null;

                                // Check if the hour and minute are the same as the previous message
                                const showDatetime =
                                  !previousTime ||
                                  currentTime.getHours() !==
                                  previousTime.getHours() ||
                                  currentTime.getMinutes() !==
                                  previousTime.getMinutes();

                                return data.user_profile_id.toString() === user.user_id.toString() ? (
                                  <li key={data.id} className="chat-message chat-message-right d-flex flex-column justify-content-end flex-column align-items-end" >
                                    {showDatetime && (
                                      <div className="text-center w-100 text-body-secondary mt-1">
                                        <small>
                                          {format(
                                            new Date(data.createdAt),
                                            "MMM dd h:mm a"
                                          )}
                                        </small>
                                      </div>
                                    )}
                                    <div className="d-flex overflow-hidden">
                                      <div className="d-flex flex-column align-items-end" style={{ maxWidth: 275 }} >
                                        <div className="chat-messages bg-label-primary mb-1" style={{ width: "fit-content" }} >
                                          <p className="mb-0">{data.message}</p>
                                        </div>
                                      </div>
                                    </div>
                                  </li>
                                ) : (
                                  <li key={data.id} className="chat-message-li">
                                    {showDatetime && (
                                      <div className="text-center w-100 text-body-secondary mt-1">
                                        <small>
                                          {format(
                                            new Date(data.createdAt),
                                            "MMM dd h:mm a"
                                          )}
                                        </small>
                                      </div>
                                    )}
                                    <div className="d-flex overflow-hidden">
                                      <div className="d-flex flex-column align-items-start">
                                        <div className="chat-messages mb-1">
                                          <p className="mb-0">{data.message}</p>
                                        </div>
                                      </div>
                                    </div>
                                  </li>
                                );
                              })}
                          </ul>
                          <div ref={lastMessageRef} />
                        </div>

                        <div className="card-footer shadow-xs">
                          <div className="d-flex justify-content-between align-items-center ">
                            <input
                              value={message}
                              className="form-control message-input border-0 me-4 shadow-none"
                              placeholder="Type your message here..."
                              onChange={(e) => setMessage(e.target.value)}
                              onKeyDown={handleKeyDown}
                            />
                            <div className="message-actions d-flex align-items-center">
                              <button type="button" onClick={(e) => { handleCreateChatMessage(e); }} className="btn btn-primary d-flex send-msg-btn" >
                                <span className="align-middle d-md-inline-block d-none">
                                  Send
                                </span>
                                <i className="icon-base bx bx-paper-plane icon-sm ms-md-2 ms-0" />
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>

                  <div className="btn-group d-flex" role="group" aria-label="Basic example" >
                    <button type="button" className="btn btn-danger mt-3 w-100" onClick={() => {
                      handleDeleteTransactionLawyer(currentAcceptedTransactionLawyerId);
                      handleDeleteChatMessage();
                      handleUpdateChatNegotiation("REJECTED");
                      handleUpdateTransaction();
                    }} >
                      <i className="bx bxs-hand me-1"></i> Cancel Negotiation5
                    </button>

                    <button
                      type="button"
                      className="btn btn-success mt-3 w-100"
                      onClick={() => {
                        // handleDeleteChatMessage();
                        // handleUpdateChatNegotiation('APPROVED');
                        handleConfirmAmount("APPROVED");
                      }}
                    >
                      <i className="bx bx-check me-1"></i>Confirm Amount
                    </button>

                    {/* <button
                          type="button"
                          className="btn btn-warning mt-3"
                          onClick={() => {
                            handleDeleteTransactionLawyer(
                              currentAcceptedTransactionLawyerId
                            );
                            handleDeleteChatMessage();
                          }}
                        >
                          <i className="bx bxs-chat me-1"></i>Cancel
                        </button> */}

                  </div>

                      <BackdropModalSmall open={openAmount} handleClose={handleCloseAmount} modalTitle="New negotiated amount" >
                        <div className="card-footer shadow-xs">
                          <div className="d-flex justify-content-between align-items-center ">
                            <CurrencyInput
                              ref={inputAmountRef}
                              value={amount}
                              onValueChange={handleValueChange}
                              intlConfig={{ locale: "en-PH", currency: "PHP" }}
                              prefix="₱"
                              decimalsLimit={2}
                              groupSeparator=","
                              decimalSeparator="."
                              placeholder="Type here the agreed amount..."
                              className="form-control message-input border-0 me-4 shadow-none"
                            />

                            <div className="message-actions d-flex align-items-center">
                              <button type="button" onClick={(e) => { handleSaveAmount(e); }} className="btn btn-primary d-flex send-msg-btn" >
                                <span className="align-middle d-md-inline-block d-none">
                                  Save
                                </span>
                                <i className="icon-base bx bx-save icon-sm ms-md-2 ms-0" />
                              </button>
                            </div>
                          </div>
                        </div>
                      </BackdropModalSmall>
                    </div>
                </BackdropModalSmall>
             

             
            </>
          )}

       
      </div>
    </div>
  );
};

export default LoadingAnimationWaitingForPrincipal;
